function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.103 18.135c.614-2.077 3.916-3.663 7.897-3.663 3.981 0 7.283 1.586 7.897 3.663A9.957 9.957 0 0022 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 2.312.785 4.441 2.103 6.135zM12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-11a4 4 0 110-8 4 4 0 010 8z",
  fill: "currentColor",
  fillRule: "evenodd"
});

var SvgAvatar = function SvgAvatar(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default __webpack_public_path__ + "edd9380fd6e9c36c173bd9de83f9e785.svg";
export { SvgAvatar as ReactComponent };